import api from '../utils/api';

class NotificationApiService {
  // Get list of notifications with filtering
  async getNotifications(params = {}) {
    try {
      const queryParams = new URLSearchParams({
        per_page: params.per_page || 20,
        page: params.page || 1,
        ...(params.unread !== undefined && { unread: params.unread }),
        ...(params.search && { search: params.search })
      });
      
      const response = await api.get(`/notifications?${queryParams}`);
      const data = response.data || response;
      
      // Handle the wrapped response structure
      if (data.notifications && data.pagination) {
        // Parse the data field if it's a JSON string
        const parsedNotifications = data.notifications.map(notification => {
          if (notification.data && typeof notification.data === 'string') {
            try {
              notification.data = JSON.parse(notification.data);
            } catch (e) {
            }
          }
          return notification;
        });
        
        return {
          data: parsedNotifications,
          ...data.pagination
        };
      }
      
      return data;
    } catch (error) {
      throw error;
    }
  }

  // Get latest notifications for bell icon (limited to 10)
  async getLatestNotifications() {
    try {
      const response = await api.get('/notifications?per_page=10&page=1');
      const data = response.data || response;
      
      // Handle the wrapped response structure
      if (data.notifications) {
        // Parse the data field if it's a JSON string
        const parsedNotifications = data.notifications.map(notification => {
          if (notification.data && typeof notification.data === 'string') {
            try {
              notification.data = JSON.parse(notification.data);
            } catch (e) {
            }
          }
          return notification;
        });
        
        return {
          data: parsedNotifications,
          total: data.pagination?.total || 0
        };
      }
      
      return data;
    } catch (error) {
      throw error;
    }
  }

  // Mark single notification as read
  async markAsRead(notificationId) {
    try {
      const response = await api.post(`/notifications/${notificationId}/read`);
      return response.data || response;
    } catch (error) {
      throw error;
    }
  }

  // Mark all notifications as read
  async markAllAsRead() {
    try {
      const response = await api.post('/notifications/read-all');
      return response.data || response;
    } catch (error) {
      throw error;
    }
  }

  // Test notification (for testing purposes)
  async sendTestNotification(data) {
    try {
      const response = await api.post('/test-notification', {
        user_id: data.user_id,
        title: data.title,
        message: data.message,
        action_url: data.action_url || '/dashboard'
      });
      return response.data || response;
    } catch (error) {
      throw error;
    }
  }

  // Get unread notification count using the dedicated endpoint
  async getUnreadCount() {
    try {
      const response = await api.get('/notifications/unread-count');
      
      const data = response.data || response;
      
      // The API might return the count in different formats
      // Handle both { count: X } and { unread_count: X } and direct number response
      if (typeof data === 'number') {
        return data;
      }

      // Check all possible fields
      const count = data.unread_notifications_count !== undefined ? data.unread_notifications_count : 0;

      return count;
    } catch (error) {
      return 0;
    }
  }

  // Delete notification
  async deleteNotification(notificationId) {
    try {
      const response = await api.delete(`/notifications/${notificationId}`);
      return response.data || response;
    } catch (error) {
      throw error;
    }
  }
}

// Create singleton instance
const notificationApiService = new NotificationApiService();

export default notificationApiService;